// extracted by mini-css-extract-plugin
export default {"headerBlock":"Header_headerBlock__h25S9","headerContainer":"Header_headerContainer__IRaYV"};